module.exports = __webpack_public_path__ + "img/section3-banner.eb5cfd46.jpg";